// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type BidContractsTableRowFragment = { __typename?: 'BidContract', id: string, isPrimary?: boolean | null | undefined, isInternalEstimate: boolean, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, latestRevision: { __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], endDate?: Types.Scalars['Date']['input'] | null | undefined, hasOutdatedScope: boolean, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, costCodes: Array<{ __typename?: 'CostCode', id: string, number: string }> } };

export const BidContractsTableRowFragmentDoc = gql`
    fragment BidContractsTableRow on BidContract {
  id
  tradePartner {
    id
    name
  }
  latestRevision {
    id
    version
    startDate
    endDate
    status {
      code
      name
    }
    costCodes {
      id
      number
    }
    hasOutdatedScope
  }
  isPrimary
  isInternalEstimate
}
    `;